import { TLanguages } from 'core/config/locale'
import getBrowserInfo from 'core/utils/getBroswerInfo'
import { versionCode } from '@/config'
import { AxiosRequestConfig } from 'axios'
import { FINGERPRINT_KEY } from 'core/utils/getDeviceId'

export enum Platform {
  Web = 1,
  Android = 2,
  Api = 3,
  H5 = 4,
  IOS = 5,
}

export enum Client {
  Web = 1,
  Android = 2,
  Api = 3,
  H5 = 4,
  IOS = 5,
}

interface DefaultQueriesConfig {
  lang: TLanguages
  platform: Platform
  client: Platform
  device_id?: string
}

export const handleDefaultClientQueries =
  ({ lang, platform, client }: DefaultQueriesConfig) =>
  (config: AxiosRequestConfig) => {
    const deviceModel = getBrowserInfo()
    if (!config.params) {
      config.params = {}
    }

    let searchParams
    if (config?.url?.includes('?')) {
      searchParams = new URLSearchParams(config.url.split('?')[1]) || config.params
    }
    let device_id
    if (typeof window !== 'undefined') {
      device_id = localStorage.getItem(FINGERPRINT_KEY)
    }

    // 通过搜索参数优先，否则使用默认配置
    config.params.lang = searchParams?.get('lang') || config?.params?.lang || lang
    config.params.platform = searchParams?.get('platform') || config?.params?.platform || platform
    config.params.client = searchParams?.get('client') || config?.params?.client || client
    config.params.deviceId = searchParams?.get('deviceId') || config?.params?.deviceId || device_id
    config.params.versionCode = searchParams?.get('versionCode') || config?.params?.versionCode || versionCode
    config.params.deviceModel =
      searchParams?.get('deviceModel') ||
      config?.params?.deviceModel ||
      (deviceModel && `${deviceModel.browser} ${deviceModel.browserVs} (${deviceModel.system})`)
        ? undefined
        : deviceModel && `${deviceModel.browser} ${deviceModel.browserVs} (${deviceModel.system})`

    if (typeof window !== 'undefined' && window.localStorage.getItem('token')) {
      const token = window.localStorage.getItem('token')
      try {
        const tokenObj = JSON.parse(token!)
        config.params.token = tokenObj.val
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        config.params.token = token
      }
    }
    return config
  }

export const handleDefaultServerQueries =
  ({ lang }: Pick<DefaultQueriesConfig, 'lang'>) =>
  async (config: AxiosRequestConfig) => {
    if (!config.params) {
      config.params = {}
    }
    config.params.lang = lang
    return config
  }
